<template lang="pug">
v-container.pa-8(fluid)
  v-row.mb-2(no-gutters align="center")
    v-col.shrink
      v-btn.ml-n3(text icon @click="goBack" height)
        v-icon(color="neutral700" :size="24") mdi-arrow-left
  v-row.pb-2.pb-md-0(no-gutters)
    //- Top Tabs
    template(v-if="selectedPatients.length")
      v-col
        .d-flex.align-center.ml-5.mt-2.pb-1
          template(v-if="!isSelectionMode")
            v-btn.button-Aa-small.mr-3.px-3(v-if="segmentTab === 0" @click="onDelete" color="danger500" height=32 outlined depressed) {{ $t('delete') }}
            v-btn.button-Aa-small.mr-3.px-3(v-else color="danger500" height=32 outlined depressed @click="showSegmentRemovePatientDialog = true") Remove from segment
            v-btn.button-Aa-small.mr-3.px-3(@click="onAddSegment" color="primary" outlined height=32 depressed) {{ $t('add_to_segment') }}
            v-btn.button-Aa-small.mr-3.px-3(@click="onSendSms" color="primary" outlined height=32 depressed) {{ $t('send_sms') }}
            v-btn.button-Aa-small.mr-3.px-3(@click="onSendEmail" color="primary" outlined height=32 depressed) {{ $t('send_email') }}
          template(v-else)
            v-btn.button-Aa-small.mr-3.px-3(v-if="isSelectionMode" color="primary" outlined height=32) ({{ selectedPatients.length }}) {{ $t('added') }}
          a.link-s(@click="clearSelection") {{ $t('clear_selection') }}
    template(v-else)
      v-col
        v-tabs(v-model="segmentTab" color="basic700" :height="44" :grow="isMobileScreen" show-arrows center-active active-class="font-semibold")
          v-tab.text-sm.font-medium.text-none.px-4(v-for="segment in segments" :key="segment.id") {{ segment.text }}

    v-col(cols="12" :md="selectedPatients.length ? 6 : 3" align="end")
      .d-flex.align-center
        v-spacer
        v-btn(@click="clickSearch" icon color="neutral500")
          v-icon(size="20") $yzi-search-sm
        v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat :placeholder="$t('type_to_search')" hide-details clearable autofocus)
        div
          customize-column-menu(type="patient" :showTooltip="false" iconSize="21")
        v-btn.button-sm.ml-4(color="neutral700" dark depressed @click="addContact") {{ $t('add_patient') }}
  //- Filter
  patients-filter-row.my-4(:filters.sync="filters" ref="filter")
  .data-table
    v-data-table.mt-sm-4.pb-6(:headers="headers" :items="customers" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetching" :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }")
      template(v-slot:no-data)
        .mt-16
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.p2.basic600--text {{ $t('no_list_available') }}
      template(v-slot:header.checked)
        yc-checkbox(v-model="checkAll" @change="onCheckedAll")
      template(v-slot:header.phone)
        span {{ 'phone' | fieldNameDisplay }}
      template(v-slot:header.total_paid)
        span {{ 'total_paid' | fieldNameDisplay }}
      template(v-slot:header.marital_status)
        span {{ 'marital_status' | fieldNameDisplay }}
      template(v-slot:item="{ item, isMobile, headers, index }")
        tr.primary--text
          template(v-for="header in headers" )
            td
              template(v-if="header.value === 'checked'")
                yc-checkbox(v-model="item.checked" @change="onChecked")
              template(v-else-if="header.value === 'name'")
                div.d-flex.my-3(style="max-width: 200px;")
                  div(style="width: 30px;")
                    v-responsive(:aspect-ratio="7/10" style="width: 30px;")
                      v-card.fill-height(v-if="item.profile_image && item.profile_image.file" flat)
                        v-img(:src="`https://img.yezza.io/50x50/${item.profile_image.path}`" height="100%" width="100%")
                          template(v-slot:placeholder)
                            v-row(class="fill-height ma-0" align="center" justify="center")
                              v-progress-circular(indeterminate color="grey")
                      v-card.neutral300.fill-height(v-else flat)
                        div.d-flex.align-center.justify-center.fill-height
                          v-icon(size="20") $yzi-user-03
                  div.pl-2
                    v-tooltip(top color="black" content-class="black tooltip-top-arrow")
                      template(#activator="{ on, attrs }")
                        div(v-bind="attrs" v-on="on" style="max-width: 145px;")
                          .text-sm.font-semibold.neutral700--text.cursor-help.truncate {{ item.name }}
                      div(style="max-width: 600px;")
                        .text-sm.font-semibold {{ item.name }}
                        .text-xs(v-if="item.dob") {{ $options.filters.getAgeByYearMonthDay(item.dob) | displayAgeByYearMonthDay }} old
                    div.d-flex.align-center
                      y-chip.mr-2(v-if="item.urgent" label="Urgent" size="xs" color="red")
                      .text-xs.neutral700--text.no-wrap(v-if="item.dob") {{ $options.filters.getAgeByYearMonthDay(item.dob) | displayAgeByYearMonthDay }} old
              template(v-else-if="header.value === 'total_paid'")
                .div {{ item.total_paid | displayPrice }}
              template(v-else-if="header.value === 'created'")
                div.text-xs.font-bold {{ (item.record_date || item.created) | humanizeDate }}
                div.text-xs {{ (item.record_date || item.created) | displayTime2 }}
              template(v-else-if="header.value === 'gender'")
                div {{ item.gender | capitalize }}
              template(v-else-if="header.value === 'marital_status'")
                div {{ item.marital_status | capitalize }}
              template(v-else-if="header.value === 'address'")
                div(v-if="item.address")
                  v-tooltip(top color="black" content-class="black tooltip-top-arrow")
                    template(#activator="{ on, attrs }")
                      .text-sm.neutral700--text.cursor-help(v-if="item.address.city" v-bind="attrs" v-on="on") {{ item.address.city }}
                    div.text-xs(style="max-width: 250px;") {{ getAddressInString(item.address) }}
              template(v-else-if="header.value === 'actions'")
                v-menu(offset-y :top="menuPositionTop(index)" left attach rounded="lg")
                  template(#activator="{ on }")
                    v-btn(icon small v-on="on")
                      v-icon mdi-dots-horizontal
                  v-list.py-0
                    v-list-item(@click="editPatient(item)")
                      v-list-item-title.text-sm.basic800--text Edit patient detail
                    v-divider
                    v-list-item(@click="openWhatsapp(item)")
                      v-list-item-title.text-sm.basic800--text Message via WhatsApp
              template(v-else)
                div {{ getFieldData(header.value, item) }}

  div.d-flex.align-center(v-if="totalCount > pageSize")
    v-spacer
    yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")

  .dialogs
    filter-customer-drawer(:open.sync="showFilterDrawer")
    delete-customer-dialog(v-if="showDeleteDialog" :open.sync="showDeleteDialog" :customers="selectedPatients" @deleted="successDeleteCustomer")
    add-to-segment-dialog(v-if="showAddDialog" :open.sync="showAddDialog" :customers="selectedPatients" @addNewSegment="fetchSegments(true)" @success="successAddCustomer")
    segment-remove-patient-dialog(v-if="showSegmentRemovePatientDialog" :open.sync="showSegmentRemovePatientDialog" :segment="selectedSegment" :customers="selectedPatients" @deleted="successRemoveSegmentCustomer")
    add-patient(v-if="showAddPatientDialog" :open.sync="showAddPatientDialog" :selectedPatient="selectedPatient" @closed="closed($event)")
    y-dialog(v-if="showAddCustomerDialog" v-model="showAddCustomerDialog" max-width=568 fluid scrollable content-class="round-2xl")
      v-card
        v-card-title.px-4 
          v-spacer 
          .text-xl.font-bold.ml-10 {{ $t('add_patient') }}
          v-spacer
          v-btn(icon @click="showAddCustomerDialog = false")
            v-icon mdi-close
        v-divider.mb-6 
        v-card-text.pt-4.pb-16.primary--text
          .pb-4
            .text-lg.font-medium.mb-2 Select your source of contact
            .text-md Choose one and click "Confirm"
          v-item-group(mandatory @change="onChanged" flat)
            div(v-for="option in addContactOptions" :key="option.id")
              v-item(v-slot="{ active, toggle }")
                .round-xl.mt-4.pa-4(:style="active ? activeStyle : inactiveStyle" @click="toggle" flat rounded="lg")
                  .text-lg.font-medium.mb-1 {{ option.title }}
                  .text-sm.neutral500--text {{ option.description }}
        v-divider
        v-card-actions.px-6.py-3
          y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click="showAddCustomerDialog = false")
          v-spacer
          y-button(label="Confirm" text-color="neutral100" color="neutral700" size="md" dark :loading="isLoading" @click="confirmAddContact")
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import FilterCustomerDrawer from '@/components/clinic/FilterCustomerDrawer.vue'
import DeleteCustomerDialog from '@/components/connect/dialogs/DeleteCustomerDialog.vue'
import AddToSegmentDialog from '@/components/clinic/patient/AddToSegmentDialog.vue'
import AddPatient from '@/components/clinic/patient/AddPatient.vue'
import SegmentRemovePatientDialog from '@/components/clinic/dialogs/SegmentRemovePatientDialog.vue'
import PatientsFilterRow from '@/components/clinic/patient/filters/PatientsFilterRow.vue'

export default {
  name: 'Patients',
  props: {
    isSelectionMode: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: 'Confirm'
    },
    loading: {
      type: Boolean,
      default: false
    },
    previousCustomers: {
      type: Array,
      default: null
    }
  },
  components: {
    CustomizeColumnMenu,
    FilterCustomerDrawer,
    DeleteCustomerDialog,
    AddToSegmentDialog,
    AddPatient,
    SegmentRemovePatientDialog,
    PatientsFilterRow
  },
  data: () => ({
    isLoading: false,
    isFetching: false,
    searchText: '',
    currentPage: 1,
    pageSize: 20,
    totalCount: 0,
    customers: [],
    selectedPatients: [],
    selectedPatient: null,
    showFilterDrawer: false,
    isDeleting: false,
    checkAll: false,
    showDeleteDialog: false,
    showAddDialog: false,
    showSearchField: false,
    showAddCustomerDialog: false,
    showAddPatientDialog: false,
    showSegmentRemovePatientDialog: false,
    addContactOptions: [
      { 
        id: 'single', 
        title: 'Add single patient', 
        description: 'Manually add a contact by filling up required field' 
      },
      { 
        id: 'csv', 
        title: 'Upload CSV', 
        description: 'Import your patients by uploading the completed csv. file template' 
      }
    ],
    selectedAddContactOption: null,
    activeStyle: {
      border: '1.5px solid #0C6DFF',
      borderRadius: '4px',
      padding: '16px',
      cursor: 'pointer'
    },
    inactiveStyle: {
      border: '1px solid var(--v-basic400)',
      borderRadius: '4px',
      padding: '16px',
      cursor: 'pointer'
    },
    isLoadingSegment: true,
    segments: [
      {
        id: 'all',
        text: 'All'
      }
    ],
    segmentTab: 0,
    selectedSegment: null,
    filters: []
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      fields: 'clinic/getPatientFields'
    }),
    headers() {
      const filteredOptions = this.fields.filter(item => item.enable)
      const checkbox = {
        text: '',
        value: 'checked',
        sortable: false
      }
      const name = {
        text: 'Name',
        value: 'name',
        class: 'text-table-header'
      }
      filteredOptions.map(item => {
        item.text = item.field_name
        item.value = `${item.id}`.toLowerCase()
        item['class'] = 'text-table-header'
      })
      const actions = {
        text: '',
        value: 'actions',
        class: 'text-table-header'
      }
      return [checkbox, name, ...filteredOptions, actions]
    },
    containFilter() {
      let data = false
      for (const key in this.filters) {
        const value = this.filters[key]
        if (value) {
          data = true
        }
      }
      return data
    },
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    pageSize() {
      this.fetchCustomers(1)
    },
    filters: {
      deep: true,
      handler() {
        this.selectedPatients = []
        this.fetchCustomers(1)
      }
    },
    segmentTab (value) {
      if (value) {
        this.selectedSegment = this.segments[value]
      } else {
        this.selectedSegment = null
      }
      this.selectedPatients = []
      this.fetchCustomers(1)
    }
  },
  created() {
    this.$store.commit('customers/resetFilters')
    this.fetchCustomFields()
    this.fetchSegments()
    this.fetchCustomers(1)
  },
  methods: {
    ...mapActions(['showMessage']),
    addFilter() {
      this.showFilterDrawer = true
    },
    getCustomers(page, pageSize, query) {
      const params = {
        page_size: pageSize,
        page,
        search: query || '',
        groups: this.selectedSegment?.id
      }
      this.filters.forEach(filter => {
        params[filter.key] = filter.value
      })
      return this.$axios.get(`/clinics/${this.company.slug}/patients`, { params })
    },
    fetchCustomers(page, query) {
      this.isFetching = true
      this.getCustomers(page, this.pageSize, query)
      .then(resp => {
        const data = resp.data
        this.customers = data.results
        this.customers.map(item => {
          item.checked = false
          if (this.previousCustomers) {
            if (this.previousCustomers.includes(item.id)) {
              item.checked = true
            }
          }
          if (!item.age && item.dob) {
            item.age = this.getAge(item.dob)
          }
        })
        this.totalCount = data.count
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isFetching = false
      })
    },
    fetchCustomFields() {
      this.$axios.get(`/connect/${this.company.slug}/customer_custom_fields?page_size=-1`)
      .then(resp => {
        const results = resp.data?.results
        if (results) {
          const fields = []
          results.forEach(field => {
            field.enable = false
            fields.push(field)
          })
          this.$store.commit('clinic/setCustomFields', fields)
        }
      })
      .catch(() => {})
    },
    fetchSegments (refetch) {
      this.isLoadingSegment = true
      const params = {
        page_size: -1,
      }
      this.$axios.get(`/connect/${this.company.slug}/groups?ordering=-id&exclude=customer`, { params })
        .then(({ data }) => {
          if (data.results) {
            const sanitizedSegments = data.results.map(result => {
              return {
                id: result.id,
                text: result.title
              }
            })
            if (refetch) {
              this.segments = [this.segments[0]]
            }
            this.segments.push(...sanitizedSegments)
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoadingSegment = false
        })
    },
    pageChanged(num) {
      this.fetchCustomers(num)
    },
    queryChanged: debounce(function (query) {
      this.fetchCustomers(1, query)
    }, 750),
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    editPatient (item) {
      this.showAddPatientDialog = true
      this.selectedPatient = item
    },
    successDeleteCustomer() {
      this.reset()
    },
    onChecked() {
      this.selectedPatients = this.customers.filter(item => item.checked === true)
      this.customers = [...this.customers]
      this.checkAll = false
      this.emitSelectedCustomers()
    },
    onCheckedAll() {
      const clone = [...this.customers]
      clone.map(item => item.checked = this.checkAll)
      this.customers = [...clone]
      this.selectedPatients = this.customers.filter(item => item.checked === true)
      this.emitSelectedCustomers()
    },
    clearSelection() {
      this.checkAll = false
      this.onCheckedAll()
    },
    onDelete() {
      this.showDeleteDialog = true
    },
    onAddSegment() {
      this.showAddDialog = true
    },
    successAddCustomer() {
      this.reset()
    },
    successRemoveSegmentCustomer() {
      this.reset()
    },
    reset() {
      this.checkAll = false
      this.selectedPatients = []
      this.fetchCustomers(1)
    },
    closed (action) {
      if (action === 'cancel') {
        // do nothing
      } else if (action === 'add') {
        this.reset()
      } else {
        this.fetchCustomers(this.currentPage)
      }
      this.selectedPatient = null
      this.showAddCustomerDialog = false
    },
    onContinue() {
      this.$emit('onContinue', this.selectedPatients)
    },
    emitSelectedCustomers() {
      this.$emit('onSelectedCustomers', this.selectedPatients)
    },
    addContact() {
      this.showAddCustomerDialog = true
    },
    onChanged(i) {
      this.selectedAddContactOption = this.addContactOptions[i]
    },
    confirmAddContact() {
      switch (this.selectedAddContactOption.id) {
        case 'integration':
          alert('Integration')
          break
        case 'csv':
          this.$router.push('/admin/clinic/patients/import')
          break
        case 'single':
          this.showAddPatientDialog = true
          break
      }
    },
    viewPatientInfo (header, item) {
      if (header.value === 'checked' || header.value === 'actions') {
        return
      }
      this.$router.push(`/admin/clinic/patient/${item.id}`)
    },
    onSendSms () {
      this.$store.commit('donation/selectDonors', this.selectedPatients)
      this.$router.push(`/admin/clinic/patients/send-message`)
    },
    onSendEmail () {
      this.$store.commit('donation/selectDonors', this.selectedPatients)
      this.$router.push(`/admin/clinic/patients/send-email`)
    },
    getFieldData(id, field) {
      const data = field[id]
      if (data) {
        return data
      }
      if (field.custom_data.length) {
        const custom = field.custom_data.find(i => `${i.id}` === id)
        if (custom) {
          return custom.value
        }
      }
      return ''
    },
    getAddressInString (addr) {
      let address = ''
      if (addr.address_1) {
        address += addr.address_1
      } if (addr.address_2) {
        address += `, ${addr.address_2}`
      } if (addr.postcode) {
        address += `, ${addr.postcode}`
      } if (addr.city) {
        address += `, ${addr.city}`
      } if (addr.state) {
        address += `, ${addr.state}`
      } if (addr.country) {
        address += `, ${addr.country}`
      }
      return address
    },
    getAge(date) {
      var today = new Date();
      var birthDate = new Date(date);
      var age = today.getFullYear() - birthDate.getFullYear();
      var month = today.getMonth() - birthDate.getMonth();
      if (month < 0 ||(month === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    openWhatsapp (item) {
      const phone = item.phone
      window.open(`https://api.whatsapp.com/send?phone=${this.$options.filters.phoneSanitized(phone)}`)
    },
    menuPositionTop (index) {
      let position = index + 1
      if (position > 7) {
        let start = this.customers.length - 2
        if (position > start) {
          return true
        }
      }
      return false
    },
    goBack () {
      this.$router.push('/admin/clinic/settings')
    },
  }
}
</script>

<style scoped>
::v-deep .v-data-table__wrapper table tbody tr:hover{
  cursor: pointer;
  background: var(--v-neutral200) !important; 
}
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>